<app-header></app-header>
<section *ngIf="!showDetails" id="dependenceCreate" class="creation-form">
  <div class="container-fluid">
    <div class="text-container">
      <div class="head">
        <div class="d-flex align-items-center">
          <a (click)="goback()"><i class="fa fa-angle-left"></i></a>
          <h5 class="form-title">{{'Enter dependence Details' | translate}}</h5>
        </div>
      </div>
      <form id="dependence-form" [formGroup]="dependenceForm" (ngSubmit)="onSubmitDependence()">
        <div class="input-container form-input">
          <div class="child-container">
            <label class="labeltxt">{{'First Name' | translate}}</label>
            <input class="" type="text" name="firstName" formControlName="firstName" maxlength="40">
            <div *ngIf="isSubmitted && f.firstName.errors" class="invalid-feedback">
              <div *ngIf="f.firstName.errors?.required">{{'First Name'|translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.firstName.errors?.pattern">{{'First Name'|translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Last Name' | translate}}</label>
            <input class="" type="text" name="lastName" formControlName="lastName" maxlength="40">
            <div *ngIf="isSubmitted && f.lastName.errors" class="invalid-feedback">
              <div *ngIf="f.lastName.errors?.required">{{'Last Name'|translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.lastName.errors?.pattern">{{'Last Name'|translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Spouse First Name' | translate}}</label>
            <input class="" type="text" name="spouse_first_name" formControlName="spouse_first_name" maxlength="40">
            <div *ngIf="isSubmitted && f.spouse_first_name.errors" class="invalid-feedback">
              <div *ngIf="f.spouse_first_name.errors?.required">{{'Spouse First Name' | translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.spouse_first_name.errors?.pattern">{{'Spouse First Name' | translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Spouse Last Name' | translate}}</label>
            <input class="" type="text" name="spouse_last_name" formControlName="spouse_last_name" maxlength="40">
            <div *ngIf="isSubmitted && f.spouse_last_name.errors" class="invalid-feedback">
              <div *ngIf="f.spouse_last_name.errors?.required">{{'Spouse Last Name' | translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.spouse_last_name.errors?.pattern">{{'Spouse Last Name' | translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Spouse CNSS no.' | translate}}</label>
            <input class="" type="text" name="spouse_cnss_no" formControlName="spouse_cnss_no" maxlength="13" (input)="formatCnss($event)">
            <div *ngIf="isSubmitted && f.spouse_cnss_no.errors" class="invalid-feedback">
              <div *ngIf="f.spouse_cnss_no.errors?.required">{{'Spouse CNSS no.' | translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.spouse_cnss_no.errors?.pattern">{{'Spouse CNSS no.' | translate}} {{'should be valid'|translate}}
                <br>{{'format is' | translate}} ###-#######-X </div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Spouse CNAMGS no.' | translate}}</label>
            <input class="" type="text" name="spouse_cnamgs_no" formControlName="spouse_cnamgs_no" maxlength="15" (input)="formatCnamgs($event)">
            <div *ngIf="isSubmitted && f.spouse_cnamgs_no.errors" class="invalid-feedback">
              <div *ngIf="f.spouse_cnamgs_no.errors?.required">{{'Spouse CNAMGS no.' | translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.spouse_cnamgs_no.errors?.pattern">{{'Spouse CNAMGS no.' | translate}} {{'should be valid'|translate}}
                <br>{{'format is' | translate}} ###-###-###-###</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Spouse CPPF no.' | translate}}</label>
            <input class="" type="text" name="spouse_cppf_no" formControlName="spouse_cppf_no" maxlength="15">
            <div *ngIf="isSubmitted && f.spouse_cppf_no.errors" class="invalid-feedback">
              <div *ngIf="f.spouse_cppf_no.errors?.required">{{'Spouse CPPF no.' | translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.spouse_cppf_no.errors?.pattern">{{'Spouse CPPF no.' | translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Spouse Professional activities' | translate}}</label>
            <input class="" type="text" name="occupation" formControlName="occupation" maxlength="40">
            <div *ngIf="isSubmitted && f.occupation.errors" class="invalid-feedback">
              <div *ngIf="f.occupation.errors?.required">{{'Spouse Professional activities' | translate}} {{'is required'|translate}}</div>
              <div *ngIf="f.occupation.errors?.pattern">{{'Spouse Professional activities' | translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'What is the nature of dependence?' | translate}}</label>
            <select class="bootstrap-select" formControlName="relation">
              <option value="2" disabled selected readonly>{{'Child' | translate}}</option>
            </select>
            <div *ngIf="isSubmitted && f.relation.errors" class="invalid-feedback">
              <div *ngIf="f.relation.errors?.required">{{'Nature of dependence'|translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Mobile Number' | translate}}</label>
            <input class="" type="tel" name="mob" formControlName="mob" maxlength="8" minlength="8">
            <div class="text-sm text-sm textUnderMobile mt-1">{{'Mobile should start with valid numbers like 77, 74, 61, 66, 62, 60, 65, 76'|translate}}</div>
            <div *ngIf="isSubmitted && f.mob.errors" class="invalid-feedback">
              <div *ngIf="f.mob.errors?.pattern || f.mob.hasError('minlength')">{{'Mobile Number'|translate}} {{'should be valid'|translate}}</div>
            </div>
          </div>
          <div class="child-container" [owlDateTimeTrigger]="dt42">
            <label class="labeltxt">{{'Date of Birth' | translate}}</label>
            <div class="date-field">
              <input class="" [max]="todayDate" [min]="minDate" [owlDateTime]="dt42" readonly name="dob" formControlName="dob" (ngModelChange)="onDobChange($event)">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
              </div>
            </div>
            <owl-date-time format="d B Y" [pickerType]="'calendar'" #dt42></owl-date-time>
            <div *ngIf="isSubmitted && f.dob.errors" class="invalid-feedback">
              <div *ngIf="f.dob.errors?.required">{{'Date of Birth'|translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label class="labeltxt">{{'Gender' | translate}}</label>
            <select class="bootstrap-select" formControlName="gender">
              <option value="0" disabled [selected]="true">{{'Gender' | translate}}</option>
              <option value="1">{{'Male' | translate}}</option>
              <option value="2">{{'Female' | translate}}</option>
              <option value="3">{{'Other' | translate}}</option>
            </select>
            <div *ngIf="isSubmitted && f.gender.errors" class="invalid-feedback">
              <div *ngIf="f.gender.errors?.required">{{'Gender'|translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <!-- <div class="child-container">
            <label class="labeltxt">{{'Marital Status' | translate}}</label>
            <select class="bootstrap-select" formControlName="marital_status">
              <option value="0" disabled [selected]="true">{{'Marital Status' | translate}}</option>
              <option value="1">{{'Spouse' | translate}}</option>
              <option value="2">{{'Unmarried' | translate}}</option>
            </select>
            <div *ngIf="isSubmitted && f.marital_status.errors" class="invalid-feedback">
              <div *ngIf="f.marital_status.errors?.required">{{'Marital Status'|translate}} {{'is required'|translate}}</div>
            </div>
          </div> -->
          <!-- <div class="child-container">
            <label class="labeltxt">{{'Occupation' | translate}}</label>
            <select class="bootstrap-select" formControlName="occupation">
              <option value="0" disabled [selected]="true">{{'Occupation' | translate}}</option>
              <option value="1">{{'Self Employed' | translate}}</option>
              <option value="2">{{'Employeees' | translate}}</option>
              <option value="3">{{'Employee manager' | translate}}</option>
              <option value="4">{{'Non-employee manager' | translate}}</option>
              <option value="5">{{'Auto entrepreneur' | translate}}</option>
              <option value="6">{{'Liberal profession' | translate}}</option>
              <option value="7">{{'Civil servant' | translate}}</option>
              <option value="8">{{'Without activity' | translate}}</option>
              <option value="9">{{'Others' | translate}}</option>
            </select>
            <div *ngIf="isSubmitted && f.occupation.errors" class="invalid-feedback">
              <div *ngIf="f.occupation.errors?.required">{{'Occupation'|translate}} {{'is required'|translate}}</div>
            </div>
          </div> -->
          <div class="child-container">
            <label for="profile_photo" class="labeltxt">{{'Upload Photo' | translate}}<span class="mandatory" *ngIf="!employee_Photo">*</span> <span *ngIf="employee_Photo" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="profile_photo" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format for photo'|translate}}</div>
            <input id="profile_photo" type="file" name="profile_photo" (change)="upload($event, 'photoFileName')" data-target="profile_photo">
            <a *ngIf="employee_Photo" id="photoFileName" class="viewFile text-center" href="{{employee_Photo}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.profile_photo.errors" class="invalid-feedback">
              <div *ngIf="f.profile_photo.errors?.required">{{'File'|translate}} {{'cannot be blank'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label for="id_front_photo" class="labeltxt">{{'Upload ID Front Photo' | translate}} <span *ngIf="id_Front_photo" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="id_front_photo" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="id_front_photo" type="file" name="dependenceIdFrontPhoto" (change)="upload($event, 'id_front_photo')" data-target="id_front_photo">
            <a *ngIf="id_Front_photo" id="frontPhotoName" href="{{id_Front_photo}}" class="viewFile text-center" target="_blank">{{'Click to view File'|translate}}</a>
            <!--  <div *ngIf="isSubmitted && f.id_front_photo.errors" class="invalid-feedback">
              <div *ngIf="f.id_front_photo.errors?.required">{{'Upload ID Front Photo'|translate}} {{'is required'|translate}}</div>
            </div> -->
          </div>
          <div class="child-container">
            <label for="id_back_photo" class="labeltxt">{{'Upload ID Back Photo' | translate}} <span *ngIf="id_Back_Photo" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="id_back_photo" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="id_back_photo" type="file" data-target="id_back_photo" name="dependenceIdBackPhoto" (change)="upload($event, 'id_back_photo')">
            <a *ngIf="id_Back_Photo" id="backPhotoName" href="{{id_Back_Photo}}" class="viewFile text-center" target="_blank">{{'Click to view File'|translate}}</a>
            <!--  <div *ngIf="isSubmitted && f.id_back_photo.errors" class="invalid-feedback">
              <div *ngIf="f.id_back_photo.errors?.required">{{'Upload ID Back Photo'|translate}} {{'is required'|translate}}</div>
            </div> -->
          </div>
          <div class="child-container">
            <label for="birthCertificate" class="labeltxt">{{'Upload Birth Certificate or Adoption Certificate' | translate}}<span class="mandatory" *ngIf="!birth_certificate_url">*</span> <span *ngIf="birth_certificate_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="birthCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="birthCertificate" type="file" name="birthCertificate" (change)="upload($event, 'birthCertificate')" data-target="birth_certificate">
            <a *ngIf="birth_certificate_url" class="viewFile text-center" href="{{birth_certificate_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.birthCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.birthCertificate.errors?.required">{{'File'|translate}} {{'Cannot be blank'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label for="prenatalCheckup" class="labeltxt">{{'Upload Prenatal check-ups of 3rd, 6th and 8th pregnancy month' | translate}}<span *ngIf="prenatalCheckup_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="prenatalCheckup" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="prenatalCheckup" type="file" name="prenatalCheckup" (change)="upload($event, 'prenatalCheckup')" data-target="prenatal_certificate">
            <a *ngIf="prenatalCheckup_url" class="viewFile text-center" href="{{prenatalCheckup_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.prenatalCheckup.errors" class="invalid-feedback">
              <div *ngIf="f.prenatalCheckup.errors?.required">{{'Upload Prenatal check-ups of 3rd, 6th and 8th pregnancy month' | translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label for="paternityCertificate" class="labeltxt">{{'Upload Certificate of paternity acknowledgement (for legitimate child and born out of wedlock bonds)' | translate}}<span *ngIf="paternityCertificate_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="paternityCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="paternityCertificate" type="file" name="paternityCertificate" (change)="upload($event, 'paternityCertificate')" data-target="paternity_certificate">
            <a *ngIf="paternityCertificate_url" class="viewFile text-center" href="{{paternityCertificate_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.paternityCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.paternityCertificate.errors?.required">{{'Upload Certificate of paternity acknowledgement (for legitimate child and born out of wedlock bonds)' | translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label for="nonAllowanceCertificate" class="labeltxt">{{'Upload Certificate of non family allowance collection (If spouse’s enrolled to CPPF, CNAMGS, ANBG)' | translate}}<span *ngIf="nonFamily_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="nonAllowanceCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="nonAllowanceCertificate" type="file" name="nonAllowanceCertificate" (change)="upload($event, 'non_Allowance_Certificate')" data-target="non_Allowance_Certificate">
            <a *ngIf="nonFamily_url" class="viewFile text-center" href="{{nonFamily_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.nonAllowanceCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.nonAllowanceCertificate.errors?.required">{{'Upload Certificate of non family allowance collection (If spouse’s enrolled to CPPF, CNAMGS, ANBG)' | translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label for="nonEnrolmentCertificate" class="labeltxt">{{'Upload Certificate of non enrolment ( If spouse is not enrolled to CPPF, CNAMGS, ANBG)' | translate}}<span *ngIf="nonEnrolment_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="nonEnrolmentCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="nonEnrolmentCertificate" type="file" name="nonEnrolmentCertificate" (change)="upload($event, 'non_Enrolment_Certificate')" data-target="non_Enrolment_Certificate">
            <a *ngIf="nonEnrolment_url" class="viewFile text-center" href="{{nonEnrolment_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.nonEnrolmentCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.nonEnrolmentCertificate.errors?.required">{{'Upload Certificate of non enrolment ( If spouse is not enrolled to CPPF, CNAMGS, ANBG)' | translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div *ngIf="f.dob.value && childAge <=20 && childAge >2" class="child-container d-flex child-checkbox">
            <label class="labeltxt m-0">{{'Child with disability or incurable illness?' | translate}}</label>
            <input type="checkbox" name="illness" (change)="onCheckboxChange($event)" formControlName="illness">
          </div>
          <div *ngIf="f.dob.value && childAge >2 && childAge <= 20" class="child-container">
            <label *ngIf="childAge >2 && childAge <= 20 && !childWithDisability" for="childCertificate" class="labeltxt">{{'Upload Certificate of school attendance' | translate}}<span *ngIf="childCertificate_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label *ngIf="childAge >2 && childAge <= 20 && childWithDisability" for="childCertificate" class="labeltxt">{{'Upload Certificate of non school attendance' | translate}}<span *ngIf="childCertificate_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="childCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="childCertificate" type="file" name="childCertificate" (change)="upload($event, 'childCertificate')" data-target="childCertificate">
            <a *ngIf="childCertificate_url" class="viewFile text-center" href="{{childCertificate_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.childCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.childCertificate.errors?.required">{{'Upload Health certificate'|translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container" *ngIf="f.dob.value && childAge <= 2">
            <label for="medicalCertificate" class="labeltxt">{{'Upload Health certificate2' | translate}}<span *ngIf="medicalCertificate_url" class="ml-1"><i class="fa   fa-check-circle"></i></span></label>
            <label for="medicalCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="medicalCertificate" type="file" name="medicalCertificate" (change)="upload($event, 'medicalCertificate')" data-target="medical_certificate">
            <a *ngIf="medicalCertificate_url" class="viewFile text-center" href="{{medicalCertificate_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.medicalCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.medicalCertificate.errors?.required">{{'Upload Medical certificate' | translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div class="child-container">
            <label for="certificateChildBirth" class="labeltxt">{{'Upload Certificate of childbirth' | translate}}<span *ngIf="certificate_childBirth_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="certificateChildBirth" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="certificateChildBirth" type="file" name="certificateChildBirth" (change)="upload($event, 'certificateChildBirth')" data-target="certificate_ChildBirth">
            <a *ngIf="certificate_childBirth_url" class="viewFile text-center" href="{{certificate_childBirth_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.certificateChildBirth.errors" class="invalid-feedback">
              <div *ngIf="f.certificateChildBirth.errors?.required">{{'Upload Certificate of childbirth' | translate}} {{'is required'|translate}}</div>
            </div>
          </div>
          <div *ngIf="childAge >2" class="child-container">
            <label for="interviewCertificate" class="labeltxt">{{'Upload Certificate of education and interview' | translate}}<span *ngIf="interviewCertificate_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
            <label for="interviewCertificate" class="file-upload-card labeltxt">
              <div class="custom-container">
                <!-- <img src="assets/images/upload_icon.png"> -->
                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                <i class="fa fa-upload" aria-hidden="true"></i>
              </div>
            </label>
            <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
            <input id="interviewCertificate" type="file" name="interviewCertificate" (change)="upload($event, 'interviewCertificate')" data-target="interview_certificate">
            <a *ngIf="interviewCertificate_url" class="viewFile text-center" href="{{interviewCertificate_url}}" target="_blank">{{'Click to view File'|translate}}</a>
            <div *ngIf="isSubmitted && f.interviewCertificate.errors" class="invalid-feedback">
              <div *ngIf="f.interviewCertificate.errors?.required">{{'File' | translate}} {{'cannot be blank'|translate}}</div>
            </div>
          </div>
        </div>
        <button type="submit" id="submit_btn" class="btn btn-main2">{{'Submit' | translate}}</button>
      </form>
    </div>
  </div>
</section>
<section *ngIf="showDetails" id="dependenceDetails">
  <div class="container-fluid">
    <div class="text-container" *ngIf="dependenceData">
      <div class="custom-container">
        <div class="backarrow">
          <a (click)="showForm()" *ngIf="!uuid"><i class="fa fa-angle-left"></i></a>
          <h4>{{ dependenceData.name }}</h4>
        </div>
        <div class="correction-buttons">
          <i *ngIf="accountDetails.current_user == 2" class="fa-solid fa-pen-to-square" (click)="editForm()"><span>{{'Correction' | translate}}</span></i>
          <i *ngIf="accountDetails.current_user == 2" class="fa-solid fa-trash ms-2 delete-btn" data-toggle="modal" data-target="#dependence-confirm-modal"><span>{{'Delete' | translate}}</span></i>  
        </div>
        <p></p>
      </div>
      <div class="input-container">
        <div class="child-container">
          <label class="labeltxt">{{'First and Last name' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.name }}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Date of Birth' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.dob }}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Gender' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.gender | translate}}</h6>
        </div>
        <!-- <div class="child-container">
          <label class="labeltxt">{{'Marital Status' | translate}} :</label>
          <h6 class="labeltxt">{{ dependenceData.marital_status  | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Occupation' | translate}} :</label>
          <h6 class="labeltxt">{{ dependenceData.occupation }}</h6>
        </div> -->
        <div class="child-container">
          <label class="labeltxt">{{'Mobile Number' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">+241 {{ dependenceData.mobile }}<span *ngIf="!dependenceData.mobile">--</span></h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Spouse First Name' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.spouse_first_name | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Spouse Last Name' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.spouse_last_name | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Spouse CNSS no.' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.spouse_cnss_no | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Spouse CNAMGS no.' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.spouse_cnamgs_no | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Spouse CPPF no.' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.spouse_cppf_no | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Spouse Professional activities' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.occupation | translate}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Nature of dependence' | translate}}&nbsp;:&nbsp;</label>
          <h6 class="labeltxt">{{ dependenceData.relation | translate}}</h6>
        </div>
        <div class="child-container d-flex">
          <a href="{{dependenceData.birthCertificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div>
                <i style="color: #818181;" class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Birth Certificate or Adoption Certificate' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.id_front_photo && dependenceData.id_front_photo != null" class="child-container d-flex">
          <a href="{{dependenceData.id_front_photo}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div>
                <i style="color: #818181;" class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'ID Front' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.id_back_photo && dependenceData.id_back_photo != null" class="child-container d-flex">
          <a href="{{dependenceData.id_back_photo}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div>
                <i style="color: #818181;" class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'ID Back' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.non_allowance_certificate && dependenceData.non_allowance_certificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.non_allowance_certificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of non family allowance collection' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.non_enrolment_certificate && dependenceData.non_enrolment_certificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.non_enrolment_certificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of non enrolment' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.paternity_certificate && dependenceData.paternity_certificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.paternity_certificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of paternity acknowledgement' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.prenatal_checkup && dependenceData.prenatal_checkup != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.prenatal_checkup}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of Prenatal check-ups of 3rd, 6th and 8th pregnancy month' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.childBirthCertificate && dependenceData.childBirthCertificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.childBirthCertificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of childbirth' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.childCertificate && dependenceData.childCertificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.childCertificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label *ngIf="dependenceData?.age >2 && dependenceData.age <= 20 && dependenceData.illness == 0" class="labeltxt readfor ml-1">{{'Certificate of school attendance' | translate}}</label>
                <label *ngIf="dependenceData?.age >2 && dependenceData.age <= 20 &&  dependenceData.illness == 1" class="labeltxt readfor ml-1">{{'Certificate of non school attendance' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.interview_certificate && dependenceData.interview_certificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.interview_certificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of education and interview' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.certificateChildBirthName && dependenceData.certificateChildBirthName != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.certificateChildBirthName}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Certificate of childbirth' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div *ngIf="dependenceData.medical_certificate && dependenceData.medical_certificate != null" class="child-container d-flex justify-content-start">
          <a href="{{dependenceData.medical_certificate}}" class="viewFile text-center w-100" target="_blank">
            <label class="file-upload-card labeltxt custom-label">
              <div class="photos-upload">
                <i class="fa fa-download" aria-hidden="true"></i><br>
                <label class="labeltxt readfor ml-1">{{'Health certificate' | translate}}</label>
              </div>
            </label>
          </a>
        </div>
        <div class="child-container">
          <label class="labeltxt">{{'Photo' | translate}} :</label>
          <div class="image-child">
            <img src="{{ dependenceData.profile_photo }}">
          </div>
        </div>
      </div>
      <!-- <button type="button" id="submit_btn" class="btn btn-main2" (click)="submitDependantsDetails()" *ngIf="!uuid">{{'Done modal' | translate}}</button> -->
      <button type="button" id="submit_btn" class="btn btn-main2" (click)="showForm(2)" *ngIf="uuid">{{'Back' | translate}}</button>
    </div>
  </div>
</section>
<div id="dependence-confirm-modal" class="modal fade rejectcalculate" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <!-- Modal content-->
    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <div class="modal-body">
        <h5>{{'Do you want to delete this dependant' | translate}}</h5>
        <div class="buttonFlex">
          <button class="reject_color" data-dismiss="modal">{{'No' | translate}}</button>
          <button (click)="deleteDependence()" type="submit" form="employeeResignForm" class="accept_color">{{'Yes' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
